import { Input } from "./input";

// TODO: separate interface from engine
class StoryDialog {
  constructor() {
    this.overlay = document.querySelector(".overlay");
    this.container = document.querySelector(".story");
  }

  handleInput(key) {
    switch (key) {
      // Consult with students before adding options
      // to quit out of stories in the middle of the flow
      //case "Escape": return Input.HideStory; break;
    }
    return false;
  }

  rescale() {
    return;
  }

  activate(context) {
    this.showStory(context.character);
    this.overlay.classList.add("is-visible");
    this.container.classList.add("is-visible");
  }

  deactivate(context) {
    this.overlay.classList.remove("is-visible");
    this.container.classList.remove("is-visible");
  }

  showStory(character) {
    this.character = character;
    this.continueStory();
  }

  endStory() {
    alert("You have recruited Herman Toothrot")
    // This might be a hacky way of communicating with the
    // ui controller as it just calls back into here anyway.
    document.dispatchEvent(new CustomEvent("ui.transition", {
      detail: {
        command: "HideStory",
      }
    }));
  }

  continueStory() {
    const story = this.character.story;
    while (story.canContinue) {
      let paragraphText = story.Continue();
      let paragraphElement = document.createElement('p');
      paragraphElement.innerHTML = paragraphText;
      this.container.appendChild(paragraphElement);
    }

    if (story.currentChoices.length == 0) {
      this.endStory();
    }

    for (const choice of story.currentChoices) {
      let choiceParagraphElement = document.createElement('p');
      choiceParagraphElement.classList.add("choice");
      choiceParagraphElement.innerHTML = `<a href='#'>${choice.text}</a>`
      this.container.appendChild(choiceParagraphElement);

      let choiceAnchorEl = choiceParagraphElement.querySelectorAll("a")[0];
      choiceAnchorEl.addEventListener("click", event => {
        event.preventDefault();
        let existingChoices = this.container.querySelectorAll('p.choice');
        for(let i=0; i<existingChoices.length; i++) {
            let c = existingChoices[i];
            c.parentNode.removeChild(c);
        }
        story.ChooseChoiceIndex(choice.index);
        this.continueStory();
      });
    }
  }

  render(stage) {
  }
}

export default StoryDialog;
